// extracted by mini-css-extract-plugin
export var attribution = "_d0-4";
export var authorName = "_d0-5";
export var quote = "_d0-3";
export var testimonial = "_d0-2";
export var trustedBy = "_d0-0";
export var trustedByLabel = "_d0-1";